import isString from "lodash/isString"
import logAction from "../partners/utils/log_action"
import logIFTTTNextAction from "../app/lib/ifttt_next_log_action"

class UserEventsTracker {
  trackPage(pageName, properties) {
    if (window.App.env && window.App.env === "production") {
      window.analytics &&
        window.analytics.page(
          window.App.pageViewData.path || pageName,
          properties
        )
      window.rudderanalytics &&
        window.rudderanalytics.page(
          window.App.pageViewData.path || pageName,
          properties
        )
    } else {
      console.log(
        "Event trackPage fired. Move ASAP to use log_ifttt_next. Data:",
        pageName,
        properties
      )
    }
  }

  trackUserInteraction(eventName, eventData) {
    if (window.App.env === "development") {
      console.log(
        "Event trackUserInteraction fired. Move ASAP to use log_ifttt_next.Data:",
        eventName,
        eventData
      )
      return
    }
    const data = { ...eventData } || {}
    data.timestamp = new Date().getTime()
    data.session_id = window.App.browserSessionId
    data.user_id = parseInt(window.App.userId) || ""
    data.anonymousId = window.App.pageViewData.anon_id

    if (eventName.includes("public_api.web_view")) {
      data.source = data.source || "web"
      data.type = "applet"
    }

    // sdk is using `applet_ids` so should pass over this case
    if (data.applet_id && !data.is_mobile_alert && !data.survey_type) {
      data.object_id = data.applet_id
      // if the id represents a legacy recipe, we want to indicate this when tracking
      data.object_type = data.type === "applet" ? "applet" : "recipe"
    } else if (data.is_mobile_alert) {
      data.object_type = "mobile_alert"
      data.object_id = data.button_type || null
    } else if (data.survey_type) {
      data.object_id = data.survey_type
    } else if (data.service_id) {
      data.object_id = data.service_id
      data.object_type = "service"
    } else if (data.category_id || data.category) {
      data.object_id = data.category_id || data.category
      data.object_type = "category"
    } else {
      data.object_id = data.object_id || null
      data.object_type = data.object_type || null
    }

    if (window.App.env && window.App.env === "production") {
      window.analytics && window.analytics.track(eventName, data)
      window.rudderanalytics && window.rudderanalytics.track(eventName, data)
    }
  }

  trackUserInteractionWithPageContext(eventName, eventData) {
    this.trackUserInteraction(eventName, {
      ...window.App.pageViewData,
      ...eventData,
    })
  }

  setReferrerForTracking() {
    //The window.document.referrer property within the web app is inconsistent because of Turbolinks, so we are caching the current page as the referrer here.
    window.App.referrer = window.location.href
  }

  domReadySetup() {
    document.addEventListener("click", this.trackCustomerEvent.bind(this))
  }

  trackCustomerEvent(event) {
    if (!event.target.dataset.trackIftttNextEvent) return

    let el = event.target
    let eventName = el.dataset.trackIftttNextEvent
    let eventData = el.dataset.trackData

    logIFTTTNextAction(eventName, {
      ...window.App.pageViewData,
      ...JSON.parse(eventData),
    })

    document.addEventListener("turbolinks:before-visit", () => {
      this.setReferrerForTracking()
    })
  }

  domPlatformReadySetup() {
    document.addEventListener("click", this.trackPlatormEvent.bind(this))
  }

  trackPlatormEvent(event) {
    // We continue using data-track-event for partners. Maintain until we move to the new system.
    const el = event.target

    if (el.dataset.trackEvent) {
      let eventName = el.dataset.trackEvent
      let eventData = el.dataset.trackData

      if (eventData) {
        eventData = isString(eventData) ? JSON.parse(eventData) : eventData
      }

      this.trackUserInteraction(eventName, {
        ...window.App.pageViewData,
        ...eventData,
      })
    } else if (el.dataset.trackPlatformEvent) {
      let eventName = el.dataset.trackPlatformEvent
      let eventData = el.dataset.trackData

      if (eventData) {
        eventData = isString(eventData) ? JSON.parse(eventData) : eventData
      }

      logAction(eventName, {
        ...window.App.pageViewData,
        ...eventData,
      })
    }
  }
}

export default UserEventsTracker
